/**
 * @file: useTrackVersionUpgraded.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */
import { Notification } from '@euler/components/snackbar/Notification';
import { presentSnackbar } from '@euler/components/snackbar/Snackbar';
import { getApplicationIdentifier } from '@euler/config';
import { kAppVersion } from '@euler/config/app-info';
import { onErrorIgnore } from '@euler/utils';
import AsyncStorage from '@react-native-async-storage/async-storage';
import * as WebBrowser from 'expo-web-browser';
import { useEffect } from 'react';

export const kReleaseNotesLink =
  'https://ota.zhichetech.com/release-notes.html';
const kVersionKey = `${getApplicationIdentifier()}.version`;

const checkVersionUpgrade = async () => {
  const previousVersion = await AsyncStorage.getItem(kVersionKey);
  if (!previousVersion || previousVersion === kAppVersion) {
    return;
  }

  await AsyncStorage.setItem(kVersionKey, kAppVersion);

  presentSnackbar({
    delay: 3000,
    dismiss: 10000,
    children: (
      <Notification
        title="已升级到最新应用版本"
        actions={[
          {
            title: '查看更新日志',
            onPress: async () => {
              await WebBrowser.openBrowserAsync(kReleaseNotesLink, {
                windowFeatures: { width: 1024, height: 700 },
              });
            },
          },
        ]}
      />
    ),
  });
};

export const useTrackVersionUpgrade = () => {
  useEffect(() => {
    if (__DEV__) {
      return;
    }

    checkVersionUpgrade().catch(onErrorIgnore);
  }, []);
};
